import "./MarketingBanner.scss";

// To show banner: set bannerOn to true, then change $promo-banner-height to 60px in vars.scss
// To hide banner: set bannerOn to false, then change $promo-banner-height to 0 in vars.scss
const bannerOn = false;

interface MarketingBannerProps {
  isVisiblePage: boolean;
}

export function MarketingBanner({ isVisiblePage }: MarketingBannerProps) {
  return bannerOn && isVisiblePage ? (<>
    <div className={`header-marketing-banner`}>
      <div className="banner-content">
        <div className="banner-text">
          <div>
            &#127881;&nbsp;&nbsp;Our gratitude! <b>Save 15% on Print&nbsp;&nbsp;•</b>&nbsp;&nbsp;Use code <b>THANKYOU15</b>
          </div>
        </div>
      </div>
    </div>
  </>) : null;
}
